import { UserPermissions } from '@App/app/entities/auth/permissions.enum';
import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * The "Add model" / "Upload photos" navigation buttons shared by the models and
 * processing site pages' left controls.
 */
@Component({
  selector: 'app-sites-add-buttons',
  templateUrl: './sites-add-buttons.component.html',
  styleUrls: ['./sites-add-buttons.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SitesAddButtonsComponent {
  @Input() companyId: number | null;
  permissions = UserPermissions;
}
